module.exports = __webpack_public_path__ + "static/media/timeline.86e1b031.jpeg";